module.exports = __webpack_public_path__ + "static/media/icebreaker.63e4c8a4.svg";